import React, { useState } from "react";
import styled from "@emotion/styled";
import { setColor } from "../../../assets/styles/styles";
import { default as Button } from "../../../components/common/button/Button";
import Typography from "../../../components/common/text/Typography";
import { AddRoomTypePrefab } from "../../../api/RoomsController";

const AddRoomTypeModal = ({ setRoomType, setIsSuccess, setSuccessMessage, setErrorMessage, setIsError, refetch }) => {
    const [roomTypeToSend, setRoomTypeToSend] = useState("");
    const [prefabRef, setPrefabRef] = useState("");

    const AddPrefab = async () => {
        const data = {
            roomType: roomTypeToSend,
            prefabRef,
        };
        const resp = await AddRoomTypePrefab(data);
        if (resp.status === 200) {
            setRoomType(resp.data.roomType);
            setPrefabRef(resp.data.prefabRef);
            setSuccessMessage("Room Type added successfully");
            setIsSuccess(true);
            setIsError(false);
        }
        if (resp.status !== 200) {
            console.log("Error adding prefab", resp);
            setRoomType("");
            setErrorMessage("Room Type addition failed");
            setRoomTypeToSend("");
            setPrefabRef("");
            setIsError(true);
            setIsSuccess(false);
        }
        refetch();
        setRoomTypeToSend("");
        setPrefabRef("");
    };

    return (
        <>
            <Card>
                <Typography variant="PinkHeading">Add Room Type and Prefab</Typography>
                <InputBox
                    type="text"
                    placeholder="Enter Room Type"
                    value={roomTypeToSend}
                    onChange={(e) => setRoomTypeToSend(e.target.value)}
                />
                <InputBox
                    type="text"
                    placeholder="Enter Prefab Ref (UUID from Unity - Optional)"
                    value={prefabRef}
                    onChange={(e) => setPrefabRef(e.target.value)}
                />

                <Button
                    variant={"PinkButton"}
                    label={"Create & Attach"}
                    margin={"1rem 0rem 0rem 0rem"}
                    onClick={AddPrefab}
                />
            </Card>
        </>
    );
};

export default AddRoomTypeModal;

const Card = styled.div`
    height: auto;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media (max-width: 768px) {
        width: 100%;
    }
`;

const InputBox = styled.input`
    padding: 10px;
    border: ${(props) => (props.errorMessage ? `1px solid ${setColor.errorColor}` : `1px solid ${setColor.grey1}`)};
    border-radius: 5px;
    color: ${setColor.inputText};
    margin: 1rem 0rem 0rem 0rem;
    width: ${(props) => (props.width ? props.width : "100%")};
    background-color: transparent;
    margin-bottom: ${(props) => (props.errorMessage ? "0.5rem" : "0rem")};
    &:disabled {
        background-color: ${setColor.grey1};
    }
`;
